import {auth} from '@/agiles/common/auth';
import Vue from 'vue';
import SignIn from './SignIn.vue';


new Vue({render: h => h(SignIn),}).$mount('#app');

// var path = window.location.pathname;
// if (auth.isResetPwd()){
//     auth.login('B2C_1_local_pwdreset','B2C_1_local');
// } else if (path == '/signin_office365'){
//     auth.login('B2C_1_office365');
// } else if (path == '/signin_google'){
//     auth.login('B2C_1_google');
// } else if (path == '/signin_local'){
//     auth.login('B2C_1_local');
// } else if (path == '/signin_local_signup'){
//     auth.login('B2C_1_local_signup','B2C_1_local');
// } else {
//     //エントリポイントのロード
//     new Vue({render: h => h(SignIn),}).$mount('#app');
// }   